import { useNavigate, useParams } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import EditCategoryModalContainer from 'modules/surveys/components/Questions/Categories/EditCategoryModalContainer'

const SurveyEditCategoryPage = () => {
  const { navigation } = useNavigation()

  const navigate = useNavigate()
  const { question_group_config_id, question_category_id, id } = useParams()

  const onClose = () =>
    navigate(navigation.processes.surveys.id.questions.fullPath({ id: String(id) }))

  return (
    <EditCategoryModalContainer
      formId={id ?? ''}
      onClose={onClose}
      questionGroupConfigId={question_group_config_id ?? ''}
      questionCategoryId={question_category_id ?? ''}
    />
  )
}

export default SurveyEditCategoryPage
